<template>
  <div class="recordDownloadStatus">
    <div class="recordDownloadStatus_data-range">
      {{ range }}
    </div>
    <div class="recordDownloadStatus_total">ファイルサイズ：約{{ size }}</div>
    <div v-if="!ready" class="recordDownloadStatus_head">
      <span>ダウンロードの準備中…</span>
      <span v-if="false">残り約1時間20分</span>
    </div>
    <v-btn
      v-if="ready"
      class="recordDownloadStatus_download"
      :loading="downloading"
      @click="handleDownload"
    >
      録画映像をダウンロードする</v-btn
    >

    <!-- FIXME: hidden -->
    <v-progress-linear
      v-if="false"
      class="recordDownloadStatus_progress"
      height="14"
      width="345"
      value="15"
    ></v-progress-linear>
    <span
      v-if="false"
      v-ripple
      class="recordDownloadStatus_cancel"
      @click="handleCancel"
      >キャンセル</span
    >
    <!-- Dialogs -->
    <template>
      <!-- Delete dialog -->
      <cancel-dialog-a
        :open="dialogCancelOpen"
        title="このダウンロードをキャンセルしますか？"
        @onClose="closeDialogCancel"
      >
        <template v-slot:actions>
          <v-btn
            class="
              recordDownloadStatus_dialog-btn recordDownloadStatus_dialog-cancel
            "
            color="text"
            @click="handleCancelOk"
          >
            ダウンロードをキャンセルする
          </v-btn>
          <v-btn
            class="
              recordDownloadStatus_dialog-btn
              recordDownloadStatus_dialog-continue
            "
            color="text"
            @click="closeDialogCancel"
          >
            ダウンロードを続ける
          </v-btn>
        </template>
      </cancel-dialog-a>
      <!-- ----------------- -->
      <!-- Message dialog -->
      <clip-dialog-message
        :open="!!dialogMessageText"
        :message="dialogMessageText"
        @onClose="closeDialogMessage"
      />
      <!-- ----------------- -->
    </template>
  </div>
</template>

<script>
import { getDayjsFromSecomDate } from '@/utils/date';
import CancelDialogA from '../../components/dialogs/CancelDialogA.vue';
import ClipDialogMessage from '../../components/dialogs/ClipDialogMessage.vue';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { downloadFromURL } from '@/utils/file';
import { bytesToGB } from '@/utils/helpers';

export default {
  name: 'RecordDownloadStatus',
  components: {
    CancelDialogA,
    ClipDialogMessage,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogCancelOpen: false,
      dialogMessageText: null,
      downloading: false,
    };
  },
  computed: {
    ...mapState({
      cameraList: (state) => state.common.cameraList,
    }),
    start() {
      return getDayjsFromSecomDate(this.record.startDate);
    },
    end() {
      return getDayjsFromSecomDate(this.record.endDate);
    },
    createDateFormat() {
      return dayjs
        .unix(this.record.createDateUnix)
        .format('YYYY/MM/DD HH:mm:ss');
    },
    range() {
      const start = this.start.format('YYYY/MM/DD HH:mm:ss');
      const end = this.end.format('YYYY/MM/DD HH:mm:ss');
      return `${start} - ${end}`;
    },
    camera() {
      return this.cameraList.find((cam) => cam.id === this.record.cameraId);
    },
    bitrate() {
      return this.camera && this.camera.bitrate ? this.camera.bitrate : null;
    },
    size() {
      if (this.bitrate) {
        return bytesToGB(
          this.getSizeBasedOnBitrate(
            this.camera.bitrate / 1000,
            dayjs.duration(this.end.diff(this.start)).asSeconds()
          )
        ).toUpperCase();
      } else {
        return '0.00GB';
      }
    },
    ready() {
      return this.record.status === 2;
    },
    urls() {
      return this.record.urls ? this.record.urls : [];
    },
  },
  watch: {
    dialogCancelOpen(val) {
      val || this.closeDialogCancel();
    },
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  methods: {
    async handleDownload() {
      try {
        this.downloading = true;
        if (this.urls && this.urls.length) {
          await Promise.all(
            this.urls.map(async (item) => {
              try {
                await downloadFromURL(item.url);
              } catch (error) {
                console.log(error);
              }
            })
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.downloading = false;
      }
    },
    getSizeBasedOnBitrate(bitrate, retentionPeriod) {
      return (bitrate / 8) * retentionPeriod;
    },
    handleCancel() {
      this.dialogCancelOpen = true;
      this.$emit('cancel');
    },
    async handleCancelOk() {
      this.closeDialogCancel();
      this.dialogMessageText = 'ダウンロードをキャンセルしました。';
    },
    closeDialogCancel() {
      this.dialogCancelOpen = false;
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.recordDownloadStatus {
  padding: 15px 0;
  &_download {
    &.theme--light.v-btn.v-btn--has-bg {
      margin-top: 10px;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      border-radius: 5px;
      width: 214px;
      height: 36px;
      background-color: #0075c2;
      color: #fff;
    }
  }
  &_data-range {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  &_total {
    font-size: 12px;
    color: #989898;
    margin-top: 5px;
  }
  &_head {
    display: flex;
    max-width: 345px;
    justify-content: space-between;
    margin-top: 10px;
    & > span {
      font-size: 14px;
      color: #4b4b4b;
    }
  }
  &_progress {
    margin-top: 10px;
    border-radius: 10px;
    max-width: 345px;
  }
  &_cancel {
    width: 80px;
    font-family: 'NotoSansJP-Regular', sans-serif;
    cursor: pointer;
    border-radius: 5px;
    padding: 5px;
    margin-top: 10px;
    font-size: 14px;
    color: #989898;
    display: block;
  }
  &_dialog {
    position: relative;
    &-continue {
      color: #666 !important;
      margin-top: 20px;
    }
    &-cancel {
      color: #eb545b !important;
      font-size: 14px !important;
      font-weight: bold !important;
    }
    &-btn {
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
  }
}
</style>
